/** At or below this many committee members present, the chairperson's vote is counted too. */
export const CHAIRPERSON_VOTE_MAX_ATTENDANCE = 3;
/** Committee members present at the meeting. The secretary records the meeting and is not counted. */
export function countPresentCommitteeMembers(attendances) {
    return attendances.filter((a) => a.presence && !a.isSecretary).length;
}
/** The chairperson votes alongside the members when only 3 committee members attend. */
export function isChairpersonVoteIncluded(attendances) {
    const chair = attendances.find((a) => a.isChairperson);
    return (!!chair?.presence &&
        countPresentCommitteeMembers(attendances) <= CHAIRPERSON_VOTE_MAX_ATTENDANCE);
}
/** Members who receive award sheet / return form approvals: those allowed to vote, plus the chairperson when their vote is included. */
export function filterVotingMembers(attendances) {
    const chairVotes = isChairpersonVoteIncluded(attendances);
    return attendances.filter((a) => a.allowVote || (chairVotes && a.isChairperson));
}
/** Everyone who signs an award sheet / return form: the voting members, plus the chairperson and secretary, who always sign. */
export function filterSigningMembers(attendances) {
    const voting = new Set(filterVotingMembers(attendances));
    return attendances.filter((a) => voting.has(a) || a.isChairperson || a.isSecretary);
}
//# sourceMappingURL=bidCommitteeVoting.js.map